
import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_audio = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/audio`,
        method: "GET",
        credentials: "include"
    });
}

export const fetch_audio_by_id = async (audio_id) => {
    if (!audio_id) return { error: "No audio id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/audio/id/${audio_id}`,
        method: "GET",
        credentials: "include"
    });
}

export const create_new_audio = async (audio_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/audio`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(audio_data),
        credentials: "include"
    });
}

export const update_audio_by_id = async (audio_id, audio_data) => {
    if (!audio_id) return { error: "No audio id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/audio/id/${audio_id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(audio_data),
        credentials: "include"
    });
}

export const delete_audio_by_id = async (audio_id) => {
    if (!audio_id) return { error: "No audio id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/audio/id/${audio_id}`,
        method: "DELETE",
        credentials: "include"
    });
}
